import { PessoaFisica } from './pessoa.model';
//import { PessoaService } from './pessoa.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ntc-pessoa',
  templateUrl: './pessoa.component.html',
  styleUrls: ['./pessoa.component.css']
})
export class PessoaComponent implements OnInit {

  listaSexo = [
    {
      id: 'M',
      descricao: 'Masculino'
    },
    {
      id: 'F',
      descricao: 'Feminino'
    }
  ];

  pessoaTeste = {
    firstName: '',
    lastName: '',
    position: '',
    officeNo: null,
    sexo: null
  };

  listaEnderecoTeste = [
    {
      rua: 'Av. Brasil',
      bairro: 'Centro',
      uf: 'PR',
      numero: 901,
      paisId: 1
    }
  ];

  listaPais = [
    {
      id: 1,
      descricao: 'Brasil'
    },
    {
      id: 2,
      descricao: 'Japão'
    },
    {
      id: 3,
      descricao: 'Argentina'
    }
  ];

  colunasGrid = [
    {
      dataField: 'rua',
      dataType: 'dxTextBox'
    },
    {
      dataField: 'bairro',
      dataType: 'dxTextBox'
    },
    {
      dataField: 'uf',
      dataType: 'dxTextBox'
    },
    {
      dataField: 'numero',
      dataType: 'dxNumberBox',
      width: 90
    },
    {
      dataField: 'paisId',
      caption: 'Pais',
      width: 125,
      lookup: {
          dataSource: this.listaPais,
          displayExpr: 'descricao',
          valueExpr: 'id'
      }
    }
  ];

  editOptionsGrid = {
    mode: 'form', //form
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Pessoa Endereços',
      showTitle: true,
      width: 700,
      height: 345,
      position: { my: 'top', at: 'top', of: window }
    }
  };

  itemsForm = [
    {
      itemType: 'group',
      caption: 'Dados Nome',
      items: []
    },
    {
      dataField: 'firstName',
      editorType: 'dxTextBox',
      label: { text: 'Nome' },
      validationRules: [{
        type: 'required',
        message: 'Nome é obrigatório'
      }]
    },
    {
      dataField: 'lastName',
      editorType: 'dxTextBox',
      label: { text: 'Sobrenome 2' }
    },
    {
      dataField: 'position',
      editorType: 'dxTextArea'
    },
    {
      dataField: 'teste',
      editorType: 'dxDateBox'
    },
    {
      dataField: 'officeNo',
      editorType: 'dxNumberBox'
    },
    {
      dataField: 'sexo',
      editorType: 'dxSelectBox',
      editorOptions: { items: this.listaSexo, displayExpr: 'descricao', valueExpr: 'id' },
      validationRules: [{
        type: 'required',
        message: 'Sexo é obrigatório'
      }]
    },
    // teste data grid 
    {
      editorType: 'dxDataGrid',
      editorOptions: {
        dataSource: this.listaEnderecoTeste,
        columns: this.colunasGrid,
        editing: this.editOptionsGrid
      }
    }
  ];

  

  gravar = function(params: any) {
    let result = params.validationGroup.validate();

    if (result.isValid) {
      console.log(this.pessoaTeste);
      console.log(this.listaEnderecoTeste);

      this.sResultado = 'Válido!';

      /*
      this.pessoaService.gravarPessoaPF(this.pessoaTeste)
      .subscribe((ret: PessoaFisica) => {
        console.log(`Pessoa gravado com sucesso! ${ret.Id}`);
      });
      */

    } else {
      this.sResultado = 'Inválido!';
    }

    this.isPopupVisible = !this.isPopupVisible;
  };


  constructor(
    //private pessoaService: PessoaService,
  ) { 
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pessoa/pessoa.component.ts